import type { RepositoryHttp } from "@/infrastructure/repositories/http";
import type { IRoutes } from "@/types/src/backend/routes";

type Route =
  IRoutes.Endpoints.Expert.Shortlist.Public.GetTalentsOfAShortlistByJobId;
type InputData = Route["params"];
export class UseCaseShortlistPublicGetTalents {
  constructor(private readonly repository: RepositoryHttp) {}

  public run = async (input: InputData) => {
    const url: Route["url"] =
      `/expert/shortlist/${input.jobId}/public/talents` as Route["url"];

    type Output = Route["outputData"];

    try {
      const result = await this.repository.findOne<Output>(String(url));
      return result;
    } catch (error) {
      return error as Route["outputData"];
    }
  };
}
